const factors = [
  'Должность и роль сотрудника',
  'Текущий уровень компетенций',
  'Опыт и стаж',
  'Задачи сотрудника',
  'Результаты оценки',
  'Карьерные планы',
  'Задачи подразделения',
  'Цели бизнеса',
];

const approach = [
  'Диагностика',
  'Определение дефицитов',
  'Индивидуальная цель',
  'Обучение',
  'Практика',
  'Обратная связь',
  'Повторная оценка',
];

export default function IndividualDevelopment() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Один и тот же тренинг не одинаково нужен всем
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Универсальная программа полезна, когда нужно сформировать общую базу. Но чем точнее развитие учитывает роль и уровень сотрудника, тем выше отдача.
        </p>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-start">
          <div>
            <p className="text-base text-gray-700 leading-relaxed mb-5">
              Развитие сотрудника имеет смысл настраивать с учётом нескольких факторов. Два сотрудника на одинаковых должностях могут нуждаться в принципиально разных компетенциях — в зависимости от опыта, задач и карьерных планов.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-6">
              {factors.map((f, i) => (
                <div key={i} className="flex items-start gap-3 bg-white rounded-xl border border-gray-100 p-4">
                  <div className="w-7 h-7 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-teal-700"></i>
                  </div>
                  <p className="text-sm text-gray-700 leading-relaxed">{f}</p>
                </div>
              ))}
            </div>

            <p className="text-sm text-gray-500 leading-relaxed">
              Индивидуальная программа не обязательна для каждого сотрудника. Это один из вариантов, который используется, когда требуется точечное развитие конкретных навыков, а не общее обучение всей команды.
            </p>
          </div>

          <div className="bg-white rounded-2xl border border-gray-200 p-6 md:p-8">
            <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-6">
              Как может строиться индивидуальное развитие
            </h3>
            <div className="space-y-3">
              {approach.map((step, i) => (
                <div key={i} className="flex items-center gap-4">
                  <div className="w-9 h-9 bg-teal-600 text-white rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-sm font-bold">{i + 1}</span>
                  </div>
                  <div className="bg-gray-50 rounded-lg px-4 py-3 flex-grow">
                    <p className="text-sm font-semibold text-gray-900">{step}</p>
                  </div>
                  {i < approach.length - 1 && (
                    <div className="hidden md:block w-0.5 h-6 bg-teal-200"></div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}